import { render, staticRenderFns } from "./raTextControl.vue?vue&type=template&id=1ace75ea&scoped=true&"
import script from "./raTextControl.vue?vue&type=script&lang=js&"
export * from "./raTextControl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ace75ea",
  null
  
)

export default component.exports